import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { max } from 'lodash'
import { CapacitiesTable } from 'Features/Projects/Scenarios/EditSettings/FactorySettings/Capacities.Table'
import { useBaseSourceSiteWorkCentre } from '../EditSettings.data'
import { EditSettingsDataFilter } from '../EditSettings.DataFilter'
import { useMemo } from 'react'

export const CapacitiesView = () => {
  const { view_width, view_height } = useWindowSize()
  const { state } = useSettingsContext()
  const { projectId, scenarioId, selectedBaseSourceSite, selectedWorkCentre } = state
  const {
    data: baseSourceSiteWorkCentre,
    isLoading,
  } = useBaseSourceSiteWorkCentre({
    projectId,
    scenarioId,
  })

  const filteredCapacitiesData = useMemo(() => {
    if (!baseSourceSiteWorkCentre) return []
    
    let filtered = baseSourceSiteWorkCentre
    
    // Filter by baseSourceSite
    if (selectedBaseSourceSite && selectedBaseSourceSite !== 'All') {
      filtered = filtered.filter(
        (item) => item.baseSourceSiteCode === selectedBaseSourceSite
      )
    }
    
    // Filter by workCentre  
    if (selectedWorkCentre && selectedWorkCentre !== 'All') {
      filtered = filtered.filter(
        (item) => item.workcentreCode === selectedWorkCentre
      )
    }
    
    return filtered
  }, [baseSourceSiteWorkCentre, selectedBaseSourceSite, selectedWorkCentre])

  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        maxWidth={view_width}
        maxHeight={max([view_height, 1500])}
      >
        <PageHeader
          title="Capacities"
          rightElement={<EditSettingsDataFilter />}
        />

        <CapacitiesTable
          data={filteredCapacitiesData}
          isLoading={isLoading}
        />
      </Box>
    </Page>
  )
}
